import { Link } from "react-router-dom";

/**
 * Vendor ↔ External User cross-link primitive, mirroring
 * BrokerCrossLinks: the PortfolioAdmin Vendor record and the vendor's
 * portal login (PortalUser, linked via LinkedVendorId) are two distinct
 * records that must always reach each other.
 *  - Vendor record → /portfolio-admin/vendors/{vendorId}  "View vendor record"
 *  - Portal account → reuse PortalAccountLink from BrokerCrossLinks.
 */

const linkClass = "text-small text-gold-shadow hover:underline";

/** Link to the PortfolioAdmin Vendor record. When `label` is omitted,
 *  renders the standard "View vendor record" affordance; pass the resolved
 *  vendor name to turn the name itself into the link. */
export function VendorRecordLink({
  vendorId,
  label,
  className,
  onClick,
}: {
  vendorId: string;
  label?: string | null;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  return (
    <Link
      to={`/portfolio-admin/vendors/${vendorId}`}
      className={className ?? linkClass}
      onClick={onClick}
      data-testid="link-vendor-record"
    >
      {label ?? "View vendor record"}
    </Link>
  );
}
